<template>
    <div class="login-page">
        <div class="header">
            <div class="icon-wrapper">
                <img src="@/assets/images/logo/sf-logo.png" alt="logo" />
            </div>
            <h3>{{ _ll('登录 / 注册') }}</h3>
            <p>{{ _ll('未注册用户登录默认注册顺丰会员') }}</p>
        </div>
        <section>
            <div class="mobile-wrap">
                <input ref="mobileInput" v-model="mobile" type="tel" :placeholder="_ll('请输入手机号')" maxlength="11" @input="isRegression" />
            </div>
            <div v-show="isBottomShow" class="code-group">
                <pwd-line ref="codeLine" @getPwd="getCode"></pwd-line>
                <button class="valid-btn" :class="{ disabled: validBtnDisable }" @click="sendCode">{{ validBtnText }}</button>
            </div>

            <div v-show="!isBottomShow" class="btn-group">
                <p class="next-step" :class="{ disabled: trimMobile.length !== 11 }" @click="nextStep">
                    下一步
                    <i class="arrow"></i>
                </p>
            </div>

            <div v-show="isBottomShow" class="express-protocol">
                <div class="btn-inner-box">
                    <!---->
                    <i class="login-checked" :class="{ cur: isLoginChecked }" @click="isLoginChecked = !isLoginChecked"></i>
                    <span>我同意</span>
                    <span class="agree" @click="openPolicy">《服务协议》<span class="black">和</span>《隐私政策》</span>
                </div>
            </div>

            <div v-show="isSubmitBtnShow" class="login-btn-wrap">
                <button type="button" class="primary-btn big" @click="loginBtn">{{ _ll('登录') }}</button>
            </div>
        </section>
        <sf-protocal ref="sfProtocal" @confirm="termsConfirm"></sf-protocal>
        <!--腾讯验证码-->
        <tencent-captcha ref="tencentCaptcha"></tencent-captcha>
        <popup-toast v-show="showPopup" res="popupToast" title="无法发送" @close="showPopup = false">
            <p class="popup-p">该号码今天接收验证短信已达上限，请明天再试</p>
        </popup-toast>
    </div>
</template>

<script>
import popupToast from '@/components/common/popup'
import tencentCaptcha from '@/components/validation/tencent-captcha'
import { getCookie, getUrlParm } from '@/util/util'
import { mobileReg } from '@/util/regs'
import ajax from '@/api/ajax'
import PwdLine from '@/components/pwdLine/pwd-line'
import Protocal from '@/components/protocal/'
import { urls } from '@/constant/paths'
import UIP2 from '@/util/uip'

const errTips = {
    122: '登录失败',
    111: '验证码错误',
    112: '验证码参数错误',
    113: '验证码未发送',
    114: '获取验证码失败',
    115: '验证码超次数，请重新获取'
}

export default {
    name: 'Login',
    components: {
        'pwd-line': PwdLine,
        'sf-protocal': Protocal,
        tencentCaptcha,
        popupToast
    },
    data() {
        return {
            mobile: '', // 手机号码
            messageCode: '', // 验证码
            isAutoLogin: true, // 自动登录，默认true
            isBottomShow: false, // 是否显示下一步
            validationShow: false, // 显示图形验证码
            validBtnDisable: false, // 发送验证码按钮是否可点击
            isLoginChecked: false, // 是否同意协议
            isSubmitBtnShow: false, // 登录按钮是否显示
            count: '', // 验证码倒计时
            showPopup: false // 短信超出上限提示
        }
    },
    computed: {
        // 发送验证码按钮文案
        validBtnText() {
            if (this.count) {
                return `重新获取${this.count}s`
            } else {
                return '发送验证码'
            }
        },

        // 校验中国大陆手机号码
        isMobileValid() {
            return mobileReg.test(this.trimMobile)
        },

        // 手机号码去空格
        trimMobile() {
            return this.mobile.replace(new RegExp(' ', 'g'), '')
        }
    },
    watch: {
        mobile() {
            if (this.mobile.length === 11) {
                this.mobile = this.mobile.replace(new RegExp(`([0-9]{${4},})`, 'g'), x =>
                    x
                        .split('')
                        .reverse()
                        .map((item, index) => (index > 0 && index % 4 === 0 ? `${item} ` : item))
                        .reverse()
                        .join('')
                )
                // 将光标移到最后一位
                setTimeout(() => {
                    this.$refs.mobileInput.setSelectionRange(13, 13)
                }, 5)
            }
        }
    },
    created() {
        if (getCookie('loginUser')) {
            this.$router.push({ name: 'waybill' })
        }
        this.type = getUrlParm('type', window.location.href)
    },
    methods: {
        // 点击下一步
        nextStep() {
            if (this.trimMobile.length === 11) {
                if (this.isMobileValid) {
                    this.isBottomShow = true
                } else {
                    this.$toast('手机号码不正确')
                }
            }
        },

        // 回退到第一步
        isRegression() {
            if (this.trimMobile.length < 11) {
                this.mobile = this.trimMobile
                this.isBottomShow = false
                this.messageCode = ''
                this.isSubmitBtnShow = false
            }
        },

        // 获取输入框中的验证码
        getCode(code) {
            this.messageCode = code
            if (code.length === 6) {
                // 直接登录或打开协议框
                if (this.isLoginChecked) {
                    this.login()
                } else {
                    this.$refs.sfProtocal.show()
                }
            } else {
                this.isSubmitBtnShow = false
            }
        },

        // 点击发送验证码事件
        sendCode() {
            if (!this.validBtnDisable) {
                this.showTencentCaptcha(this.sendPhoneMsg)
            }
        },

        // 协议与隐私政策弹出
        openPolicy() {
            this.$refs.sfProtocal.show()
        },

        // 协议条款确认
        termsConfirm(isAgree) {
            this.isLoginChecked = isAgree
            if (isAgree) {
                if (this.isMobileValid && this.messageCode.length === 6) {
                    this.login()
                }
            } else {
                if (this.messageCode.length === 6) {
                    this.isSubmitBtnShow = true
                }
            }
        },

        // 验证码可发送倒计时
        getCodeReset: function () {
            const TIME_COUNT = 60
            if (!this.timer) {
                this.count = TIME_COUNT
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--
                    } else {
                        clearInterval(this.timer)
                        this.timer = null
                        this.validBtnDisable = false
                    }
                }, 1000)
            }
        },

        // 图形验证码成功回调
        getCodeSuccess(msg) {
            this.validBtnDisable = true
            this.getCodeReset()
        },

        // 图形验证码错误回调
        getCodeError(msg) {
            this.$toast(msg)
        },

        // 登录
        login() {
            const params = {
                mobile: this.trimMobile,
                rememberMe: this.isAutoLogin
            }
            const headers = {
                'SMS-Verification-App': 'user',
                'SMS-Verification-Code': this.messageCode,
                'SMS-Verification-Mobile': this.trimMobile,
                'SMS-Verification-Mobile-Area': ''
            }
            ajax.login({ params, headers })
                .then(res => {
                    const data = res.data
                    if (data.code === 0) {
                        this.redirect()
                    } else if (data.code === 120) {
                        // 未注册
                        ajax.regist({ params, headers }).then(() => {
                            this.redirect()
                        })
                    } else {
                        this.$toast(errTips[data.code] || '网络错误')
                        this.$refs.codeLine.clear()
                        this.messageCode = ''
                        this.isSubmitBtnShow = false
                    }
                })
                .catch(res => {
                    this.$toast('网络错误')
                })
        },

        // 登录跳转
        redirect() {
            // 增加神策通用属性 登录标志
            UIP2.sensor.addAttribute({
                is_login: true // 是否登录判定已登录界面真实登录为基准值
            })
            if (this.type && this.type.startsWith('WX_CX3')) {
                // 登录成功后调用获取ticket接口
                ajax.getTicket({
                    params: { ts: new Date().getTime() }
                })
                    .then(res => {
                        if (res.data.code === 0) {
                            const ticket = res.data.result
                            const href = `${urls.MP_CHECK_TICKET}?type=${this.type}&ticket=${ticket}`
                            window.location.href = href
                        } else {
                            window.location.href = '/mobile/cn/sc/'
                        }
                    })
                    .catch(() => {
                        window.location.href = '/mobile/cn/sc/'
                    })
            } else {
                window.location.href = '/mobile/cn/sc/'
            }
        },

        // 点击登录按钮
        loginBtn() {
            if (this.isLoginChecked && this.messageCode.length === 6) {
                this.login()
            } else {
                this.openPolicy()
            }
        },

        // 调用腾讯验证码
        showTencentCaptcha(callback) {
            this.$refs.tencentCaptcha.getCaptcha(callback)
        },

        // 发送手机短信
        sendPhoneMsg(retJson, isNew = true) {
            const headers = {
                'X-TC-TICKET': retJson.ticket,
                // 旧：CaptchaCheck 新：DescribeCaptchaResult
                'X-TC-VERSION': isNew ? 'DescribeCaptchaResult' : 'CaptchaCheck'
            }
            if (isNew) {
                headers['X-TC-RANDSTR'] = retJson.randstr
            }
            ajax.tencentNotification({
                params: {
                    mobile: this.trimMobile,
                    app: 'user',
                    area: ''
                },
                headers
            })
                .then(res => {
                    const data = res.data
                    if (!data || data.code !== 0) {
                        let errorMsg = ''
                        if (data.code == 410) {
                            this.showPopup = true
                        } else if (data.code == 400) {
                            errorMsg = '手机号错误'
                        } else {
                            errorMsg = data.message || '验证失败'
                        }
                        if (errorMsg) {
                            return this.$toast(errorMsg)
                        }
                    } else {
                        this.getCodeSuccess()
                    }
                })
                .catch(res => {
                    const errorMsg = '验证失败'
                    return this.$toast(errorMsg)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.mobile-wrap {
    margin-bottom: 80px;
}
.mobile-wrap input {
    border-bottom: 0.03rem solid #ccc;
}
.next-step.disabled {
    background-color: #999999;
}
.login-page {
    padding: 125px 50px;
}
.header {
    margin-bottom: 80px;
    position: relative;
    padding-left: 120px;
    h3 {
        font-size: 40px;
    }
    p {
        color: $gray;
        font-size: 20px;
    }
}
.icon-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    img {
        width: 88px;
        height: 88px;
    }
}
.form-group {
    margin-bottom: 50px;
}
input[type='checkbox'] {
    width: 25px;
    height: 25px;
    position: relative;
    top: 2px;
}
.sms-verification input {
    width: 47%;
    margin-right: 3%;
}
.sms-verification button {
    width: 50%;
    position: relative;
    bottom: 2px;
    min-width: auto;
}
.code-group {
    position: relative;
}
.valid-btn {
    position: absolute;
    top: 0;
    right: 10px;
    background: none;
    border: none;
    font-size: 28px;
}
.login-checked {
    width: 0.3rem;
    height: 0.3rem;
    border: 0.02rem solid #dc1e32;
    background-color: #f2f2f2;
    position: relative;
    top: -0.03rem;
    left: -0.06rem;
    display: inline-block;
}
.next-step {
    background-color: #dc1e32;
    border-radius: 50px;
    color: white;
    float: right;
    width: 250px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: none;
    position: relative;
}
.arrow:before {
    content: '';
    display: block;
    position: absolute;
    width: 30px;
    height: 10px;
    border-top: 3px solid #fff;
    background: transparent;
    z-index: 9;
    transform: rotate(45deg);
    transform-origin: 2px 5px;
}
.arrow:after {
    content: '';
    display: block;
    position: absolute;
    width: 13px;
    height: 13px;
    border-left: 3px solid #fff;
    border-top: 3px solid #fff;
    background: transparent;
    z-index: -1;
}
.arrow {
    display: block;
    position: absolute;
    -webkit-transform: rotate(135deg);
    transform: rotate(135deg);
    right: 40px;
    top: 48px;
}
.express-protocol {
    text-align: center;
    padding-top: 100px;
}
.login-checked {
    vertical-align: middle;
}

.login-checked.cur:before {
    content: '';
    width: 8px;
    height: 3px;
    transform: rotate(45deg);
    background-color: #dc1e32;
    position: absolute;
    display: block;
    top: 16px;
    left: 4px;
}
.login-checked.cur:after {
    content: '';
    width: 18px;
    height: 3px;
    transform: rotate(-45deg);
    background-color: #dc1e32;
    position: absolute;
    display: block;
    top: 13px;
    left: 6px;
}
.agree {
    color: rgb(220, 30, 50);
}
.agree .black {
    color: #333;
}
.login-btn-wrap {
    text-align: center;
    position: fixed;
    bottom: 80px;
    left: 0;
    width: 100%;
}
.primary-btn {
    width: 80%;
}
.popup-p {
    font-size: 0.26rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue